import React from "react";
import { Link } from "react-router-dom";

const ShippingDelivery = () => {
  return (
    <>
      <section className="section pricing__v2 cu_mtpd" id="pricing">
        <div className="container">
          <div className="row mb-5">
            <div className="col-md-5 mx-auto text-center">
              <span
                className="subtitle text-uppercase mb-3"
                data-aos="fade-up"
                data-aos-delay={0}
              >
                Policies
              </span>
              <h2 className="mb-3 text-[32px]" data-aos="fade-up" data-aos-delay={100}>
                Shipping & Delivery Policy
              </h2>
              <p data-aos="fade-up" data-aos-delay={200}>
                Efficient Shipping & Delivery Policies to Ensure On-Time Service
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 mb-4 mb-md-0" data-aos="fade-up" data-aos-delay={300}>
              <ul>
                <li>
                  1. Service orders are fulfilled by empanelled providers through qualified technicians.
                </li>
                <li>
                  2. Product orders are shipped via registered domestic courier/speed post.
                </li>
                <li>
                  3. Shipping occurs within 0-7 days or as per the agreed delivery date.
                </li>
                <li>
                  4. We are not liable for courier delays but guarantee handover within 0-7 days.
                </li>
                <li>
                  5.	Delivery is to the address provided by the buyer.
                </li>
                <li>
                  6.	Service delivery is confirmed via your registered mail ID.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default ShippingDelivery;
